export function isObject(paramObj: unknown): boolean {
  return (
    paramObj !== null &&
    !Array.isArray(paramObj) &&
    typeof paramObj === 'object'
  )
}

// eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
export function objectTest(paramObj: unknown): paramObj is Object {
  return isObject(paramObj)
}

// eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
export function keyTest(obj: Object, key: string): key is keyof typeof obj {
  return key in obj
}
